import {UserServiceClient} from '@multipass-user-service';

import {LegalDocument, LegalDocumentMapper} from './legalDocumentMapper';

export interface LegalDocumentsService {
    getCurrentDocuments(): Promise<LegalDocument[]>;
}

export class DefaultLegalDocumentsService implements LegalDocumentsService {
    #legalDocumentMapper = new LegalDocumentMapper();
    readonly #userServiceClient: UserServiceClient;

    constructor(userServiceClient: UserServiceClient) {
        this.#userServiceClient = userServiceClient;
    }

    public async getCurrentDocuments(): Promise<LegalDocument[]> {
        const response = await this.#userServiceClient.requestGetLegalDocuments({});
        return response.documents.map(dto => this.#legalDocumentMapper.mapLegalDocumentFromDto(dto));
    }
}
